// CCS deep links are keyed on the prescriptionId (CCS calls it pdrId, patient drug regimen id).
const CCS_BASE_URL = "https://us-west-2.beta.tools.pharmacy.amazon.dev";
const PHARMACIST_TASK_TYPE = "pv1";

export const buildPharmacistUrl = (prescriptionId: string): string =>
    `${CCS_BASE_URL}/ccs/clinical-verification-v2?pdrId=${encodeURIComponent(prescriptionId)}`
    + `&taskType=${PHARMACIST_TASK_TYPE}`;

export const buildDataEntryUrl = (prescriptionId: string): string =>
    `${CCS_BASE_URL}/ccs/data-entry?pdrId=${encodeURIComponent(prescriptionId)}`;
